import DatePickerLocale from 'rmc-date-picker/lib/locale/ru_RU';
export default DatePickerLocale;
